import React, { Component, MouseEvent } from "react";
import classnames from "classnames";

import { Icon } from "@formant/ui/component/common/Icon";

import { Button } from "../Button";
import { Chip } from "../Chip";
import { IMenuItem } from "./IMenuItem";
import * as styles from "./MenuItem.scss";

export interface IMenuItemProps<
    T = string,
    TGroup extends string | number = number,
> extends IMenuItem<T, TGroup> {
    hovered: boolean;
    onHover: (value: T) => void;
    tooltip?: string;
}

export class MenuItem<
    T,
    TGroup extends string | number = number,
> extends Component<IMenuItemProps<T, TGroup>> {
    public render() {
        const {
            value,
            label,
            chipClassName,
            icon,
            extraIcon,
            selected,
            hovered,
            className,
            hoverClass,
            extra,
            tooltip,
            hotkey,
            disabled = false,
        } = this.props;

        return (
            <Button
                className={classnames(
                    styles["menu-item"],
                    styles.button,
                    className,
                    selected && styles.selected,
                    hovered && styles.hovered,
                    hovered && hoverClass,
                )}
                disabled={disabled}
                onMouseDown={this.onMouseDown}
                onClick={this.onClick}
                onMouseEnter={this.onMouseEnter}
                type="button"
                data-tooltip={tooltip}
                data-testid={this.props["data-testid"]}
            >
                {chipClassName && <Chip className={chipClassName} />}
                {icon && <Icon name={icon} />}
                <span className={styles["label-value"]}>
                    {label || (value as unknown as string)}
                </span>
                {extraIcon}
                {extra}
                {hotkey !== undefined &&
                    hotkey
                        .split("+")
                        .map((_, index) =>
                            _ === "shift" ? (
                                <Icon
                                    key={`hotkeyIcon ${_} ${index}`}
                                    name="shift"
                                />
                            ) : (
                                _.toUpperCase()
                            ),
                        )}
                {selected !== undefined && (
                    <Icon name="check" className={styles.check} />
                )}
            </Button>
        );
    }

    private onMouseDown = (event: MouseEvent) => {
        const { value, onSelected } = this.props;

        event.preventDefault();
        event.stopPropagation();

        if (event.button === 0 && onSelected) {
            onSelected(value);
        }
    };

    private onClick = (event: MouseEvent) => {
        event.stopPropagation();
    };

    private onMouseEnter = () => {
        const { value, onHover } = this.props;
        onHover(value);
    };
}
